import React, { type FormEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelDashboardOption,
  deleteWorkspace,
} from "../../state/workspaces/workspaces.actions";
import { selectSelectedWorkspace } from "../../state/workspaces/workspaces.selector";
import { useI18n } from "../../utils/hooks/use.i18n";
import { ConfirmationDialog } from "./ConfirmationDialog";

export const DeleteWorkspaceDialog = () => {
  const dispatch = useDispatch();

  const tWorkspaceCard = useI18n("WORKSPACE_CARD.");
  const tDeleteWorkspaceDrawer = useI18n("DELETE_WORKSPACE_DRAWER.");

  const selectedWorkspace = useSelector(selectSelectedWorkspace);

  const submitHandler = (e: FormEvent) => {
    e.preventDefault();
    if (!selectedWorkspace) return;

    const { hasPassword, workspaceId } = selectedWorkspace;

    let password: string | undefined;

    if (hasPassword) {
      const form = new FormData(e.target as HTMLFormElement);
      password = form.get("password")?.toString(); // NOSONAR: 'form.get("password")' may use Object's default stringification format ('[object Object]') when stringified.sonarqube(typescript:S6551)
    }

    dispatch(deleteWorkspace.request({ workspaceId, password }));
  };

  return (
    <ConfirmationDialog
      buttonText={tWorkspaceCard("DELETE")}
      cancelAction={() => dispatch(cancelDashboardOption())}
      confirmDelete={tDeleteWorkspaceDrawer("CONFIRM_DELETE")}
      confirmWithCheckmark
      icon="hoylu-ui-icons-trash"
      message={tDeleteWorkspaceDrawer(
        "WARNING",
        selectedWorkspace?.workspaceName ?? "",
      )}
      passwordRequired={!!selectedWorkspace?.hasPassword}
      submitAction={submitHandler}
      title={tDeleteWorkspaceDrawer(
        "DELETE",
        selectedWorkspace?.workspaceName ?? "",
      )}
    />
  );
};

export default DeleteWorkspaceDialog;
